// extracted by mini-css-extract-plugin
export default {"box":"PerfilUsuario_box__j6s-4","imagen":"PerfilUsuario_imagen__va373"};